'use strict';

import {findInput} from '../../utils';


export default function($log, $compile, $parse, $timeout, $animate) {
	'ngInject';

	return {
		priority: 10,
		require: '^form',
		link: link,
		scope: {},
	};

	function link(scope, element, attrs, $form) {
		var input = findInput(element);
		var name = input.attr('name');
		var label = element.find('label');

		input.attr('ng-model', `$form.$rest.$data.${name}`);

		var form = $compile(`
			<div brg-rest-field-linked ng-form>
				${element.prop('innerHTML')}
				<div ng-messages="$localForm.${name}.$error"
						 ng-show="$localForm.displayErrors">
					<div ng-repeat="error in $form.$rest.$errors.${name}">{{ error }}</div>
					<div ng-message="required">This field may not be blank.</div>
					<div ng-message="email">Please provide a valid email.</div>
					<div ng-message="mask">This field is incomplete.</div>
					<div ng-message="minlength">This field is too short.</div>
					<div ng-message="maxlength">This field is too long.</div>
					<div ng-message="time">Please input a time in the form HH:MM AM/PM (e.g. 2:35 PM).</div>
					<div ng-message="components">There is not enough data available for this address.</div>
				</div>
			</div>`)(scope);

		element.replaceWith(form);
		input = findInput(form);

		// Make the parent and child forms aware of each other
		scope.$form = $form;
		scope.$localForm = form.controller('form');
		$form.$addControl(scope.$localForm);

		// User-friendly errors
		var errorTimeout;
		var hasError = 
			`($localForm.${name}.$invalid && $localForm.${name}.$dirty) || !!$form.$rest.$errors.${name}`;
		input.controller('ngModel').$viewChangeListeners.push(updateErrorStatus);
		input.on('blur', updateErrorStatus.bind(null, 0));
		scope.$watch(`!!$form.$rest.$errors.${name}`, updateErrorStatus.bind(null, 0));

		function updateErrorStatus(delay) {
			if(!Number.isInteger(delay)) {
				delay = 3000;
			}

			if (errorTimeout) {
				$timeout.cancel(errorTimeout);
			}

			if($parse(hasError)(scope)) {
				errorTimeout = $timeout(function() {
					scope.$localForm.displayErrors = true;
					$animate.addClass(form, 'has-error');
				}, delay);
			} else {
				scope.$localForm.displayErrors = false;
				$animate.removeClass(form, 'has-error');
			}

		}
	}
}
